import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

// Layouts
import AuthLayout from '@/layouts/AuthLayout';
import DashboardLayout from '@/layouts/DashboardLayout';
import Content from '@/layouts/Content';

// Generel
import NotFound from '@/layouts/NotFound';

// Dashboard Page
import Dashboard from '@/pages/Dashboard'
import DashboardChart from '@/pages/DashboardChart';
// import DashboardMnu from '@/pages/DashboardMnu';
import Profile from '@/pages/Profile/Overview';

// Vehicle Dashboard Page
import VehicleDashboard from '@/pages/VehicleDashboard';

import Available from '@/pages/VehicleDashboard/Available';
import AvailableShow from '@/pages/Settings/Vehicle/Show';

import OnTheRoad from '@/pages/VehicleDashboard/OnTheRoad';
import OnTheRoadShow from '@/pages/Settings/Vehicle/Show';

import RoadTax from '@/pages/VehicleDashboard/RoadTax';
import RoadTaxShow from '@/pages/VehicleDashboard/RoadTaxDetail';
import RoadTaxDetail from '@/pages/Settings/Vehicle/RoadTax/RoadTaxDetail';
import RoadTaxEdit from '@/pages/Settings/Vehicle/RoadTax/FormEdit';
import TypeVehicleDetail from '@/pages/Settings/Vehicle/TypeVehicleDetail';

import Insurance from '@/pages/VehicleDashboard/Insurance';
import InsuranceShow from '@/pages/VehicleDashboard/InsuranceDetail';
import InsuranceDetail from '@/pages/Settings/Vehicle/Insurance/InsuranceDetail';
import InsuranceEdit from '@/pages/Settings/Vehicle/Insurance/FormEdit';

import Penalty from '@/pages/VehicleDashboard/Penalty';
import PenaltyShow from '@/pages/VehicleDashboard/PenaltyDetail';
import PenaltyDetail from '@/pages/Settings/Vehicle/Penalty/PenaltyDetail';
import PenaltyEdit from '@/pages/Settings/Vehicle/Penalty/FormEdit';

import Services from '@/pages/VehicleDashboard/Services';
import ServicesShow from '@/pages/VehicleDashboard/ServiceDetail';
import ServiceDetail from '@/pages/Settings/Vehicle/Services/ServiceDetail';
import ServiceEdit from '@/pages/Settings/Vehicle/Services/FormEdit';

import Repair from '@/pages/VehicleDashboard/Repair';
import RepairShow from '@/pages/VehicleDashboard/RepairDetail';
import RepairDetail from '@/pages/Settings/Vehicle/Repair/RepairDetail';
import RepairEdit from '@/pages/Settings/Vehicle/Repair/FormEdit';

import AttendanceSettingIndex from "@/pages/Settings/AttendanceSetting/Index"

// Overtime Type Page
import OvertimeTypeIndex from '@/pages/Settings/OvertimeType/Index';

// Leave Page
import LeaveIndex from '@/pages/Leave/Index';
import LeaveShow from '@/pages/Leave/Show';

// Leave Type Page
import LeaveTypeIndex from '@/pages/Settings/LeaveType/Index';

/** ================================== Reimburse Old Version ================================= */

// reimbursement Provider pages
import ReimbursementIndexOld from '@/pages/Reimbursement/Index';

// General Reimbursement Page
import GeneralReimbursementIndexOld from '@/pages/Reimbursement/General/Index';
import GeneralReimbursementShowOld from '@/pages/Reimbursement/General/Show';

// Payment Reimbursement Page
import PaymentReimbursementIndexOld from '@/pages/Reimbursement/Payment/Index';
import PaymentReimbursementShowOld from '@/pages/Reimbursement/Payment/Show';

// Reimbursement Category
// import AddCategory from '@/pages/Reimbursement/Category/AddCategory';
// import DetailCategory from '@/pages/Reimbursement/Category/DetailCategory';
// import EditCategory from '@/pages/Reimbursement/Category/EditCategory';

//REimbursement History
// import HistoryReimbursementIndex from '@/pages/Reimbursement/History/Index';
// import HistoryReimbursementShow from '@/pages/Reimbursement/History/Show';




/** ======================================================================= */

// Reimbursement Provider pages
import ReimbursementIndex from '@/pages/NewReimbursement/Index';

// General Reimbursement Page
import GeneralReimbursementIndex from '@/pages/NewReimbursement/General/Index';
import GeneralReimbursementShow from '@/pages/NewReimbursement/General/Show';

// Payment Reimbursement Page
import PaymentReimbursementIndex from '@/pages/NewReimbursement/Payment/Index';
import PaymentReimbursementShow from '@/pages/NewReimbursement/Payment/Show';

// Reimbursement Category
import AddCategory from '@/pages/NewReimbursement/Category/AddCategory';
import DetailCategory from '@/pages/NewReimbursement/Category/DetailCategory';
import EditCategory from '@/pages/NewReimbursement/Category/EditCategory';

//REimbursement History
import HistoryReimbursementIndex from '@/pages/NewReimbursement/History/Index';
import HistoryReimbursementShow from '@/pages/NewReimbursement/History/Show';
import DetailPaidReimbursement from '@/pages/NewReimbursement/History/Detail';


// Overtime Page
import OvertimeIndex from '@/pages/Overtime/Index';
import OvertimeShow from '@/pages/Overtime/Show';

// Reimbursement Type Page
import ReimbursementTypeIndex from '@/pages/Settings/ReimbursementType/Index';

// Timesheet Page
import TimesheetIndex from '@/pages/Timesheet/Index';
import TimesheetShow from '@/pages/Timesheet/Show';

// Purchase Requisition Page
import PurchaseRequisitionIndex from '@/pages/PurchaseRequisition/Index';
import PurchaseRequisitionShow from '@/pages/PurchaseRequisition/Show';

// Customer Page
import CustomerIndex from '@/pages/Company/Customer/Index';
import CustomerShow from '@/pages/Company/Customer/Show';
import CustomerForm from '@/pages/Company/Customer/Form';
import CustomerEdit from '@/pages/Company/Customer/FormEdit';

//Supplier page
import SupplierIndex from '@/pages/Company/Supplier/Index';
import SupplierForm from '@/pages/Company/Supplier/Form';
import SupplierShow from '@/pages/Company/Supplier/Show';
import SupplierEdit from '@/pages/Company/Supplier/Edit';

// Customer Page
import ItemIndex from '@/pages/Sales/Item/Index';
import ItemShow from '@/pages/Sales/Item/Show';
import ItemForm from '@/pages/Sales/Item/Form';

// Sales Page
import SalesOrderIndex from '@/pages/Sales/SalesOrder/Index';
import SalesOrderShow from '@/pages/Sales/SalesOrder/Show';
import SalesOrderForm from '@/pages/Sales/SalesOrder/Form';

// Filter Sales
import DailySales from '@/pages/Sales/SalesOrder/FilterSales/DailySales';
import MonthlySales from '@/pages/Sales/SalesOrder/FilterSales/MonthlySales';
import YearlySales from '@/pages/Sales/SalesOrder/FilterSales/YearlySales';

// Quotation Page
import QuotationIndex from '@/pages/Sales/Quotation/Index';
import QuotationShow from '@/pages/Sales/Quotation/Show';
import QuotationForm from '@/pages/Sales/Quotation/Form';
import QuotationEdit from '@/pages/Sales/Quotation/FormEdit';

//Invoice Page
import InvoiceIndex from '@/pages/Sales/Invoice/Index';
import InvoiceShow from '@/pages/Sales/Invoice/Show';
import InvoiceForm from '@/pages/Sales/Invoice/Form';
import InvoiceEdit from '@/pages/Sales/Invoice/Edit';

// User Page
import UserIndex from '@/pages/Settings/User/Index';
import UserShow from '@/pages/Settings/User/Show';
import UserForm from '@/pages/Settings/User/Form';

// Vehicle Page
import VehicleIndex from '@/pages/Settings/Vehicle/Index';
import VehicleForm from '@/pages/Settings/Vehicle/Form';
import VehicleShow from '@/pages/Settings/Vehicle/Show';

// Vehicle Category Page
import VehicleCategoryIndex from '@/pages/Settings/VehicleCategory/Index';

// Photo Category Page
import PhotoCategoryIndex from '@/pages/Settings/PhotoCategory/Index';

// QR Code Page
import QRCodeIndex from '@/pages/Settings/QRCode/Index';

// Access Provider Pages
import AccessIndex from '@/pages/Settings/Access/Index';

// User Access Page
import UserAccessIndex from '@/pages/Settings/Access/UserAccess/Index';

// Module Access Page
import ModuleAccessIndex from '@/pages/Settings/Access/ModuleAccess/Index';

//Stock Area Page
import StockAreaIndex from '@/pages/Settings/StockArea/Index';

// Branch Page
import BranchIndex from '@/pages/Company/Branch/Index';
import BranchForm from '@/pages/Company/Branch/Form';
import BranchShow from '@/pages/Company/Branch/Show';

// Company Page
import CompanyIndex from '@/pages/Company/Company/Index';
import CompanyForm from '@/pages/Company/Company/Form';
import CompanyShow from '@/pages/Company/Company/Show';
import CompanyFormEdit from '@/pages/Company/Company/FormEdit';

// Department Page
import DepartmentIndex from '@/pages/Company/Department/Index';
import DepartmentForm from '@/pages/Company/Department/Form';
import DepartmentShow from '@/pages/Company/Department/Show';

// Employee Page
import EmployeeIndex from '@/pages/Company/Employee/Index';
import EmployeeForm from '@/pages/Company/Employee/Form';
import EmployeeShow from '@/pages/Company/Employee/Show';

// Document Page
import DocumentsIndex from '@/pages/Documents/Index';
import DocumentsForm from '@/pages/Documents/Form';
import DocumentsShow from '@/pages/Documents/Show';

// Vehicle Report Page
import VehicleReportIndex from '@/pages/Reports/VehicleReport/Index';
import VehicleReportShow from '@/pages/Reports/VehicleReport/Show';

// WeeklyTimesheet Report Page
import WeeklyTimesheetIndex from '@/pages/Reports/WeeklyTimesheet/Index';
// import WeeklyTimesheetShow from '@/pages/Reports/WeeklyTimesheet/Show'

// worksheet page
import WorksheetIndex from '@/pages/Worksheet/Index';
import WorksheetShow from '@/pages/Worksheet/Show';


// worksheet type page
import WorksheetTypeIndex from '@/pages/Settings/WorksheetType/Index'

// Auth Page
import Login from '@/pages/Auth/Login';
import Logout from '@/pages/Auth/Logout';

// Receipt Page
import ReceiptIndex from '@/pages/Sales/Receipt/Index';
import ReceiptShow from '@/pages/Sales/Receipt/Show';
import ReceiptForm from '@/pages/Sales/Receipt/Form';
import ReceiptEdit from '@/pages/Sales/Receipt/Edit';

// Attendance Page
import AttendanceIndex from '@/pages/Attendance/Index';
import AttendanceShow from '@/pages/Attendance/Show';
import AttendanceDetail from '@/pages/Attendance/Detail';
import AttendanceHistories from '@/pages/Attendance/Histories';

//Accounting Page
import AccountIndex from '@/pages/Accounting/Account/Index';
import AccountForm from '@/pages/Accounting/Account/Form';

import JournalIndex from '@/pages/Accounting/Journal/Index';
import JournalForm from '@/pages/Accounting/Journal/Form';
import JournalShow from '@/pages/Accounting/Journal/Show';

// import CashInIndex from '@/pages/Accounting/CashIn/Index';
// import CashInForm from '@/pages/Accounting/CashIn/Form';
// import CashInDetail from '@/pages/Accounting/CashIn/Detail';

// import CashOutIndex from '@/pages/Accounting/CashOut/Index';
// import CashOutForm from '@/pages/Accounting/CashOut/Form';
// import CashOutDetail from '@/pages/Accounting/CashOut/Detail';

import StockInIndex from '@/pages/Inventory/StockIn/Index'
import StockInForm from '@/pages/Inventory/StockIn/Form'
import StockInShow from '@/pages/Inventory/StockIn/Show'
import StockInEdit from '@/pages/Inventory/StockIn/Edit'
import StockInEditNew from '@/pages/Inventory/StockIn/EditNew'

import StockOutIndex from '@/pages/Inventory/StockOut/Index'
import StockOutForm from '@/pages/Inventory/StockOut/Form'
import StockOutShow from '@/pages/Inventory/StockOut/Show'
import StockOutEditNew from '@/pages/Inventory/StockOut/EditNew'

import StockItemListIndex from '@/pages/Inventory/StockItemList/Index'
import StockItemListShow from '@/pages/Inventory/StockItemList/Show'

// import StockOutIndex from '@/pages/Accounting/StockOut/Index'
// import StockOutForm from '@/pages/Accounting/StockOut/Form'
// import StockOutShow from '@/pages/Accounting/StockOut/Show'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: DashboardChart,
        meta: { requiredNotAllowRole: ['Transportation'] },
      },
      {
        path: '/vehicle',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Vehicle',
            component: VehicleDashboard,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'create',
            name: 'Create Vehicle',
            component: VehicleForm,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: '/vehicle',
            alias: '/',
            name: 'Vehicle Dashboard',
            component: VehicleDashboard,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'available',
            name: 'Available',
            component: Available,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'available/:uuid',
            name: 'Detail Available',
            component: AvailableShow,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'on-the-road',
            name: 'On The Road',
            component: OnTheRoad,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'on-the-road/:uuid',
            name: 'Detail On The Road',
            component: OnTheRoadShow,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'road-tax',
            name: 'Road Tax',
            component: RoadTax,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'road-tax/:uuid',
            name: 'Road Tax',
            component: RoadTax,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'road-tax-detail/:uuid',
            name: 'Detail Road Tax',
            component: RoadTaxDetail,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'road-tax-detail/:uuid/edit',
            name: 'Edit Road Tax',
            component: RoadTaxEdit,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'insurance',
            name: 'Insurance',
            component: Insurance,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'insurance/:uuid',
            name: 'Insurance',
            component: Insurance,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'insurance-detail/:uuid',
            name: 'Detail Insurance',
            component: InsuranceDetail,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'insurance-detail/:uuid/edit',
            name: 'Edit Insurance',
            component: InsuranceEdit,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'type-vehicle-detail/:uuid',
            name: 'Detail',
            component: TypeVehicleDetail,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'penalty',
            name: 'Penalty',
            component: Penalty,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'penalty/:uuid',
            name: 'Detail Penalty',
            component: PenaltyShow,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'penalty-detail/:uuid',
            name: 'Detail Penalty',
            component: PenaltyDetail,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'penalty-detail/:uuid/edit',
            name: 'Edit Penalty',
            component: PenaltyEdit,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'services',
            name: 'Service',
            component: Services,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'services/:uuid',
            name: 'Service',
            component: Services,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'service-detail/:uuid',
            name: 'Detail Service',
            component: ServiceDetail,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'service-detail/:uuid/edit',
            name: 'Edit Service',
            component: ServiceEdit,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'repair',
            name: 'Repair',
            component: Repair,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'repair/:uuid',
            name: 'Detail Repair',
            component: RepairShow,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'repair-detail/:uuid',
            name: 'Detail Repair',
            component: RepairDetail,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: 'repair-detail/:uuid/edit',
            name: 'Edit Repair',
            component: RepairEdit,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: ':uuid',
            name: 'Detail Vehicle',
            component: VehicleShow,
            meta: { requiredNotAllowRole: [] },
          },
          {
            path: ':uuid/edit',
            name: 'Edit Vehicle',
            component: VehicleForm,
            meta: { requiredNotAllowRole: [] },
          },
        ],
      },
      {
        path: '/overtime',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Overtime',
            component: OvertimeIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Overtime',
            component: OvertimeShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/attendance',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Attendance',
            component: AttendanceIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Attendance',
            component: AttendanceShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid/histories',
            name: 'Employee History',
            component: AttendanceHistories,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid/history',
            name: 'History Detail',
            component: AttendanceDetail,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      
      {
        path: '/leave',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Leave',
            component: LeaveIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Leave',
            component: LeaveShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/settings/access',
        component: AccessIndex,
        redirect: 'settings/access/user-access',
        children: [
          {
            path: 'user-access',
            name: 'User Access Empty Container',
            component: Content,
            children: [
              {
                path: 'index',
                alias: '/',
                name: 'User Access',
                component: UserAccessIndex,
                meta: { requiredNotAllowRole: ['Transportation'] },
                // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
              },
            ],
          },
          {
            path: 'module-access',
            name: 'Module Access Empty Container',
            component: Content,
            children: [
              {
                path: 'index',
                alias: '/',
                name: 'Module Access',
                component: ModuleAccessIndex,
                meta: { requiredNotAllowRole: ['Transportation'] },
                // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
              },
            ],
          },
        ],
      },
      /** ================================================================================== */
      // {
      //   path: '/reimbursement',
      //   component: ReimbursementIndexOld,
      //   redirect: 'reimbursement/general',
      //   children: [
      //     {
      //       path: 'general',
      //       name: 'General Empty Container',
      //       component: Content,
      //       children: [
      //         {
      //           path: 'index',
      //           alias: '/',
      //           name: 'General Reimbursement',
      //           component: GeneralReimbursementIndexOld,
      //           meta: { requiredNotAllowRole: ['Transportation'] },
      //           // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
      //         },
      //         {
      //           path: ':uuid',
      //           name: 'General Reimbursement Detail',
      //           component: GeneralReimbursementShowOld,
      //           meta: { requiredNotAllowRole: ['Transportation'] },
      //           // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
      //         },
              
      //       ],
      //     },
         
      //     {
      //       path: 'payment',
      //       name: 'Payment Empty Container',
      //       component: Content,
      //       children: [
      //         {
      //           path: 'index',
      //           alias: '/',
      //           name: 'Payment Reimbursement',
      //           component: PaymentReimbursementIndexOld,
      //           meta: { requiredNotAllowRole: ['Transportation'] },
      //           // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
      //         },
      //         {
      //           path: ':uuid',
      //           name: 'Payment Reimbursement Detail',
      //           component: PaymentReimbursementShowOld,
      //           meta: { requiredNotAllowRole: ['Transportation'] },
      //           // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
      //         },
      //       ],
      //     },

      //     // =================================================== //
      //     {
      //       path: 'category-reimbursement',
      //       name: 'Category Reimbursement',
      //       component: Content,
      //       children: [
      //         {
      //           path: 'index',
      //           alias: '/',
      //           name: 'Category Reimbursement',
      //           component: AddCategory,
      //           meta: { requiredNotAllowRole: ['Transportation'] },
      //         },
      //         {
      //           path: ':uuid',
      //           name: 'Detail Category',
      //           component: DetailCategory,
      //           meta: { requiredNotAllowRole: ['Transportation'] },
      //         },
      //         {
      //           path: ':uuid/edit',
      //           name: 'Edit Category',
      //           component: EditCategory,
      //           meta: { requiredNotAllowRole: ['Transportation'] },
      //         },
      //       ],
      //     },
      //     {
      //       path: 'history-reimbursement',
      //       name: 'History Reimbursement',
      //       component: Content,
      //       children: [
      //         {
      //           path: 'index',
      //           alias: '/',
      //           name: 'History Reimbursement',
      //           component: HistoryReimbursementIndex,
      //           meta: { requiredNotAllowRole: ['Transportation'] },
      //         },
      //         {
      //           path: ':uuid',
      //           name: 'Detail History Reimbursement',
      //           component: HistoryReimbursementShow,
      //           meta: { requiredNotAllowRole: ['Transportation'] },
      //         }
      //       ]
      //     }
      //   ],
      // },
      {
        path: '/new-reimbursement',
        component: ReimbursementIndex,
        redirect: 'new-reimbursement/general',
        children: [
          {
            path: 'general',
            name: 'General Empty Container',
            component: Content,
            children: [
              {
                path: 'index',
                alias: '/',
                name: 'Requested Reimbursement',
                component: GeneralReimbursementIndex,
                meta: { requiredNotAllowRole: ['Transportation'] },
                // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
              },
              {
                path: ':uuid',
                name: 'General Reimbursement Detail',
                component: GeneralReimbursementShow,
                meta: { requiredNotAllowRole: ['Transportation'] },
                // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
              },
              
            ],
          },
         
          {
            path: 'payment',
            name: 'Payment Empty Container',
            component: Content,
            children: [
              {
                path: 'index',
                alias: '/',
                name: 'Approved Reimbursement',
                component: PaymentReimbursementIndex,
                meta: { requiredNotAllowRole: ['Transportation'] },
                // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
              },
              {
                path: ':uuid',
                name: 'Approved Reimbursement Detail',
                component: PaymentReimbursementShow,
                meta: { requiredNotAllowRole: ['Transportation'] },
                // meta: { requiredNotAllowRole: ['Manager', 'Transportation']}
              },
            ],
          },
          {
            path: 'category-reimbursement',
            name: 'Category Reimbursement',
            component: Content,
            children: [
              {
                path: 'index',
                alias: '/',
                name: 'Category Reimbursement',
                component: AddCategory,
                meta: { requiredNotAllowRole: ['Transportation'] },
              },
              {
                path: ':uuid',
                name: 'Detail Category',
                component: DetailCategory,
                meta: { requiredNotAllowRole: ['Transportation'] },
              },
              {
                path: ':uuid/edit',
                name: 'Edit Category',
                component: EditCategory,
                meta: { requiredNotAllowRole: ['Transportation'] },
              },
            ],
          },
          {
            path: 'history-reimbursement',
            name: 'History Reimbursement',
            component: Content,
            children: [
              {
                path: 'index',
                alias: '/',
                name: 'Paid Reimbursement',
                component: HistoryReimbursementIndex,
                meta: { requiredNotAllowRole: ['Transportation'] },
              },
              {
                path: ':uuid',
                name: 'History Paid Reimbursement',
                component: HistoryReimbursementShow,
                meta: { requiredNotAllowRole: ['Transportation'] },
              },
              {
                path: ':uuid/detail',
                name: 'Detail Paid Reimbursement',
                component: DetailPaidReimbursement,
                meta: { requiredNotAllowRole: ['Transportation'] },
              }
            ]
          }
        ],
      },
      {
        path: '/my-job',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'My Job',
            component: TimesheetIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail My Job',
            component: TimesheetShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/worksheet',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Worksheet',
            component: WorksheetIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Worksheet',
            component: WorksheetShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          }
        ]
      },
      {
        path: '/purchase-requisition',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Purchase Requisition',
            component: PurchaseRequisitionIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Purchase Requisition',
            component: PurchaseRequisitionShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/accounting/account-list',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Account',
            component: AccountIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Account',
            component: AccountForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          }
        ],
      },
      {
        path: '/accounting/journal',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Journal',
            component: JournalIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Journal',
            component: JournalForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Journal',
            component: JournalShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          }
        ]
      },
      // {
      //   path: 'accounting/cash-in',
      //   component: Content,
      //   children: [
      //     {
      //       path: 'index',
      //       alias: '/',
      //       name: 'Cash In',
      //       component: CashInIndex,
      //       meta: { requiredNotAllowRole: ['Transportation'] },
      //     },
      //     {
      //       path: 'create',
      //       name: 'Create Cash In',
      //       component: CashInForm,
      //       meta: { requiredNotAllowRole: ['Transportation'] },
      //     },
      //     {
      //       path: ':uuid',
      //       name: 'Detail Cash In',
      //       component: CashInDetail,
      //       meta: { requiredNotAllowRole: ['Transportation'] },
      //     }
      //   ]
      // },
      // {
      //   path: 'accounting/cash-out',
      //   component: Content,
      //   children: [
      //     {
      //       path: 'index',
      //       alias: '/',
      //       name: 'Cash Out',
      //       component: CashOutIndex,
      //       meta: { requiredNotAllowRole: ['Transportation'] },
      //     },
      //     {
      //       path: 'create',
      //       name: 'Create Cash Out',
      //       component: CashOutForm,
      //       meta: { requiredNotAllowRole: ['Transportation'] },
      //     },
      //     {
      //       path: ':uuid',
      //       name: 'Detail Cash Out',
      //       component: CashOutDetail,
      //       meta: { requiredNotAllowRole: ['Transportation'] },
      //     }
      //   ]
      // },
      {
        path: 'inventory/stock-item-list',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Stock Item List',
            component: StockItemListIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Stock Item List',
            component: StockItemListShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          }
        ],
      },
      {
        path: 'inventory/stock-in',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Stock In',
            component: StockInIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Stock In',
            component: StockInForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Stock In',
            component: StockInShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Stock In',
            component: StockInEditNew,
            meta: { requiredNotAllowRole: ['Transportation'] },
          }
        ]
      },
       {
        path: 'inventory/stock-out',
        component: Content,
        children: [
          {
            path: 'Index',
            alias: '/',
            name: 'Stock Out',
            component: StockOutIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Stock Out',  
            component: StockOutForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Stock Out',
            component: StockOutShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Stock Out',
            component: StockOutEditNew,
            meta: { requiredNotAllowRole: ['Transportation'] },
          }
        ]
      },
      {
        path: 'settings/user',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Users',
            component: UserIndex,
            meta: { requiredNotAllowRole: ['Manager', 'Transportation'] },
          },
          {
            path: 'create',
            name: 'Create User',
            component: UserForm,
            meta: { requiredNotAllowRole: ['Manager', 'Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Users',
            component: UserShow,
            meta: { requiredNotAllowRole: ['Manager', 'Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Users',
            component: UserForm,
            meta: { requiredNotAllowRole: ['Manager', 'Transportation'] },
          },
        ],
      },
      {
        path: '/reports/vehicle',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Vehicle Report',
            component: VehicleReportIndex,
            meta: { requiredNotAllowRole: ['Manager', 'Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Vehicle Report Details',
            component: VehicleReportShow,
            meta: { requiredNotAllowRole: ['Manager', 'Transportation'] },
          },
        ],
      },
      {
        path: '/reports/weekly-my-job',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Weekly My Job Report',
            component: WeeklyTimesheetIndex,
            meta: { requiredNotAllowRole: ['Manager', 'Transportation'] },
          },
        ],
      },
      {
        path: 'company-structure/branch',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Branch',
            component: BranchIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Branch',
            component: BranchForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Branch',
            component: BranchShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Branch',
            component: BranchForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: 'company-structure/company',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Company',
            component: CompanyIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Company',
            component: CompanyForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Company',
            component: CompanyShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Company',
            component: CompanyForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: 'company-structure/department',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Department',
            component: DepartmentIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Department',
            component: DepartmentForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Department',
            component: DepartmentShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Department',
            component: DepartmentForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: 'company-structure/employee',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Employee',
            component: EmployeeIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Employee',
            component: EmployeeForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Employee',
            component: EmployeeShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Employee',
            component: EmployeeForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/company-structure/customer',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Customer',
            component: CustomerIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Customer',
            component: CustomerForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Customer',
            component: CustomerShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Customer',
            component: CustomerEdit,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: 'company-structure/supplier',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Supplier',
            component: SupplierIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'add-supplier',
            name: 'Create Supplier',
            component: SupplierForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Supplier',
            component: SupplierShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Supplier',
            component: SupplierEdit,
            meta: { requiredNotAllowRole: ['Transportation'] },

          }
        ],
      },
      {
        path: '/sales/items',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Item List',
            component: ItemIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Items',
            component: ItemForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Items',
            component: ItemShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Items',
            component: ItemForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/sales/sales-order',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Sales Order',
            component: SalesOrderIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Sales Order',
            component: SalesOrderShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Sales Order',
            component: SalesOrderForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/sales/daily-sales',
        name: 'Daily Sales',
        component: DailySales,
        meta: { requiredNotAllowRole: ['Transportation'] },
      },
      {
        path: '/sales/monthly-sales',
        name: 'Monthly Sales',
        component: MonthlySales,
        meta: { requiredNotAllowRole: ['Transportation'] },
      },
      {
        path: '/sales/yearly-sales',
        name: 'Yearly Sales',
        component: YearlySales,
        meta: { requiredNotAllowRole: ['Transportation'] },
      },
      {
        path: '/sales/quotation',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Quotation',
            component: QuotationIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Quotation',
            component: QuotationForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Quotation',
            component: QuotationShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid/edit',
            name: 'Edit Quotation',
            component: QuotationEdit,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/sales/invoice',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Invoice List',
            component: InvoiceIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            alias: '/',
            name: 'Create Invoice',
            component: InvoiceForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            alias: '/',
            name: 'Detail Invoice',
            component: InvoiceShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Invoice',
            component: InvoiceEdit,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ]
      },
      {
        path: '/sales/delivery-order',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Delivery Order',
            component: ReceiptIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Delivery Order',  
            component: ReceiptForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Delivery Order',
            component: ReceiptShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':id/edit',
            name: 'Edit Delivery Order',
            component: ReceiptEdit,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/documents',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Documents',
            component: DocumentsIndex,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: 'create',
            name: 'Create Documents',
            component: DocumentsForm,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
          {
            path: ':uuid',
            name: 'Detail Documents',
            component: DocumentsShow,
            meta: { requiredNotAllowRole: ['Transportation'] },
          },
        ],
      },
      {
        path: '/settings/user',
        component: Content,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'User',
            component: UserIndex,
            meta: { requiredNotAllowRole: ['Manager', 'Transportation'] },
          },
          {
            path: ':uuid',
            name: 'User Details',
            component: UserShow,
            meta: { requiredNotAllowRole: ['Manager', 'Transportation'] },
          },
        ],
      },
      {
        path: '/settings/overtime-type',
        name: 'Overtime Type',
        component: OvertimeTypeIndex,
        meta: { requiredNotAllowRole: ['Transportation'] },
        // meta: { requiredNotAllowRole: ['Manager', 'Transportation'] }
      },
      {
        path: '/settings/leave-type',
        name: 'Leave Type',
        component: LeaveTypeIndex,
        meta: { requiredNotAllowRole: ['Transportation'] },
        // meta: { requiredNotAllowRole: ['Manager', 'Transportation'] }
      },
      {
        path: '/settings/worksheet-type',
        name: 'Worksheet Type',
        component: WorksheetTypeIndex,
        meta: { requiredNotAllowRole: ['Transportation'] },
      },
      {
        path: '/settings/attendance-setting',
        name: 'Attendance Setting',
        component: AttendanceSettingIndex,
        meta: { requiredNotAllowRole: ['Transportation'] },
      },
      {
        path: '/settings/reimbursement-type',
        name: 'Reimbursement Type',
        component: ReimbursementTypeIndex,
        meta: { requiredNotAllowRole: ['Transportation'] },
        // meta: { requiredNotAllowRole: ['Manager', 'Transportation'] }
      },
      {
        path: '/settings/vehicle-category',
        name: 'Vehicle Category',
        component: VehicleCategoryIndex,
        meta: { requiredNotAllowRole: ['Transportation'] },
        // meta: { requiredNotAllowRole: ['Manager', 'Transportation'] }
      },
      {
        path: '/settings/photo-category',
        name: 'Photo Category',
        component: PhotoCategoryIndex,
        meta: { requiredNotAllowRole: ['Transportation'] },
        // meta: { requiredNotAllowRole: ['Manager', 'Transportation'] }
      },
      {
        path: '/settings/qrcode',
        name: 'QR Code',
        component: QRCodeIndex,
        meta: { requiredNotAllowRole: ['Transportation'] },
        // meta: { requiredNotAllowRole: ['Manager', 'Transportation'] }
      },
      {
        path: '/settings/stock-area',
        name: 'Stock Area',
        component: StockAreaIndex,
        meta: { requiredNotAllowRole: ['Transportation'] },
      },
      // {
      //   path: '/settings/department',
      //   name: 'Department',
      //   component: DepartmentIndex,
      //   meta: { requiredNotAllowRole: ['Manager', 'Transportation'] }
      // },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: { requiredNotAllowRole: [] },
      },
      {
        path: '/documents',
        name: 'Documents',
        component: DocumentsShow,
        meta: { requiredNotAllowRole: ['Transportation'] },
      },
      
    ],
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    component: AuthLayout,
    children: [
      {
        path: 'index',
        alias: '/',
        name: 'Login',
        component: Login,
      },
    ],
    meta: { requiresGuest: true },
  },
  {
    path: '/logout',
    component: Logout,
    meta: { requiresAuth: true, requiredNotAllowRole: [] },
  },
  {
    path: '*',
    component: NotFound,
  },
  {
    path: '403',
    component: NotFound,
  },
];

Vue.use(VueRouter);
const router = new VueRouter({
  routes, // short for router: router
  linkActiveClass: 'active',
});

if (store.getters['account/isLoggedIn']) {
  store.dispatch('account/saveTokens', {
    tokens: store.getters['account/tokens'],
    accountData: null,
    isLocalLogin: true,
  });
}

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // console.log(to)
    var y = to.meta.requiredNotAllowRole;
    console.log('type of ', y);
    if (!store.getters['account/isLoggedIn']) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
      // } else if (to.meta.requiredNotAllowRole === store.getters['account/accountData'].role) {
      //   next({
      //     path: '/403'
      //   })
    } else if (y.includes(store.getters['account/accountData'].role)) {
      next({
        path: '/403',
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresGuest)) {
    if (store.getters['account/isLoggedIn']) {
      next({
        path: '/',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
